import { render, staticRenderFns } from "./PickupPoints.vue?vue&type=template&id=0e17d251&"
import script from "./PickupPoints.vue?vue&type=script&lang=js&"
export * from "./PickupPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports